import { render, staticRenderFns } from "./GenerateCertificatedTableModal.vue?vue&type=template&id=66087886&scoped=true&"
import script from "./GenerateCertificatedTableModal.vue?vue&type=script&lang=js&"
export * from "./GenerateCertificatedTableModal.vue?vue&type=script&lang=js&"
import style0 from "./GenerateCertificatedTableModal.vue?vue&type=style&index=0&id=66087886&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66087886",
  null
  
)

export default component.exports